import { __ } from "@wordpress/i18n";
import { useContext } from "react";
import SbUtils from "../../Utils/SbUtils";
import Button from "../Common/Button";
import ModalContainer from "../Global/ModalContainer";

const UpsellPopupModal = ( props ) => {

    const upsellModal = props.upsellModal;
    const upsellContent = upsellModal.upsellActive !== false && props?.upsellContent[upsellModal.upsellActive] !== undefined ? props?.upsellContent[upsellModal.upsellActive] : null;

    // Features organized in 3 columns (matching prototype)
    const upsellFeatures = [
        // Column 1
        [
            __('Display TripAdvisor Reviews', 'sb-customizer'),
            __('One-click templates', 'sb-customizer'),
            __('Mobile design support', 'sb-customizer')
        ],
        // Column 2
        [
            __('Moderate review feeds', 'sb-customizer'),
            __('Advanced filtering', 'sb-customizer'),
            __('Custom icons', 'sb-customizer')
        ],
        // Column 3
        [
            __('Display images and videos', 'sb-customizer'),
            __('Carousel layout', 'sb-customizer'),
            __('Pro support', 'sb-customizer')
        ]
    ];

    const includedButtons = upsellContent?.buttons ? Object.keys(upsellContent?.buttons) : [];

    return (
        (upsellModal.upsellActive !== false && upsellContent !== null )&&
            <ModalContainer
                size='medium'
                closebutton={true}
                onClose={ () => {
                    upsellModal.setUpsellActive( false )
                } }
            >

                <div className='sb-upsell-modal sb-fs'>
                    {/* Top Section - Gray Background */}
                    <div className='sb-upsell-modal-top sb-fs'>
                        <div className='sb-upsell-modal-heading sb-fs'>
                            <h2 className="sb-upsell-modal-title">{ upsellContent.heading }</h2>
                            {
                                upsellContent.description &&
                                <p className="sb-upsell-modal-description">{ upsellContent.description }</p>
                            }
                            {/* Discount Badge */}
                            {
                                includedButtons.includes('lite') &&
                                <div className='sb-upsell-discount-badge'>
                                    <div className='sb-upsell-discount-icon'>
                                        { SbUtils.printIcon( 'tag' ) }
                                    </div>
                                    <div className='sb-upsell-discount-text'>
                                        <span className='sb-upsell-discount-title'>
                                            { __('Lite Feed Users get 50% OFF', 'sb-customizer') }
                                        </span>
                                        <span className='sb-upsell-discount-subtitle'>
                                            { __('auto-applied at checkout', 'sb-customizer') }
                                        </span>
                                    </div>
                                </div>
                            }
                        </div>
                        {/* Image */}
                        {
                            upsellContent?.image &&
                            <div className='sb-upsell-modal-image'>
                                <div className='sb-upsell-modal-image-placeholder'>
                                    <img src={ window.sb_customizer.assetsURL + 'sb-customizer/assets/images/' + upsellContent?.image } alt={__( 'Upsell Modal Icon', 'sb-customizer' )} />
                                </div>
                            </div>
                        }
                    </div>

                    {/* Features Section */}
                    {
                        upsellContent?.includeContent === true &&
                        <div className='sb-upsell-modal-features'>
                            <h3 className='sb-upsell-features-heading'>{ __('And get much more!', 'sb-customizer') }</h3>
                            <div className='sb-upsell-features-grid'>
                                {
                                    upsellFeatures.map( (column, colIndex) => (
                                        <div className='sb-upsell-features-column' key={colIndex}>
                                            {
                                                column.map( (feature, featureIndex) => (
                                                    <div className='sb-upsell-feature-item' key={featureIndex}>
                                                        <span className='sb-upsell-feature-dot'></span>
                                                        <span className='sb-upsell-feature-label'>{ feature }</span>
                                                    </div>
                                                ))
                                            }
                                        </div>
                                    ))
                                }
                            </div>
                        </div>
                    }

                    {/* Buttons Section */}
                    {
                        ( includedButtons.includes('upgrade') || includedButtons.includes('demo') || includedButtons.includes('learnMore') ) &&
                        <div className='sb-upsell-modal-buttons'>
                            {
                                includedButtons.includes('upgrade') &&
                                <Button
                                    customClass='sb-upsell-upgrade-btn'
                                    size='large'
                                    type='brand'
                                    text={ __('Upgrade', 'sb-customizer') }
                                    icon='rocket'
                                    link={upsellContent?.buttons['upgrade']}
                                    target={upsellContent?.buttons['upgrade'] ? '_blank' : false}
                                />
                            }
                            {
                                ( includedButtons.includes('demo') || includedButtons.includes('learnMore') ) &&
                                <Button
                                    customClass='sb-upsell-learn-btn'
                                    size='large'
                                    type='secondary'
                                    text={ __('Learn More', 'sb-customizer') }
                                    icon='chevron-right'
                                    iconPosition='right'
                                    link={upsellContent?.buttons['demo'] || upsellContent?.buttons['learnMore']}
                                    target={(upsellContent?.buttons['demo'] || upsellContent?.buttons['learnMore']) ? '_blank' : false}
                                />
                            }
                        </div>
                    }
                </div>

            </ModalContainer>
    )
}

export default UpsellPopupModal;
